// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "dist/js/" + {"10":"service-overview-view","229":"awards-view","233":"single-press-view","321":"contact-view","372":"home-view","418":"team-view","457":"single-news-view","466":"service-view","556":"news-view","628":"about-view","812":"npm.swiper","885":"projects-view","975":"single-project-view"}[chunkId] + ".js";
};